import React from 'react';
import PropTypes from 'prop-types';

const TrustPilotWidget = ({ trustBoxRef }) => (
  <div
    ref={trustBoxRef}
    className="trustpilot-widget"
    data-locale="en-GB"
    data-template-id="53aa8807dec7e10d38f59f32"
    data-businessunit-id="50e4972a0000640005203fa3"
    data-style-height="64px"
    data-style-width="115px"
    data-theme="dark"
  >
    <a
      href="https://uk.trustpilot.com/review/matchbook.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      Trustpilot
    </a>
  </div>
);

TrustPilotWidget.propTypes = {
  trustBoxRef: PropTypes.object.isRequired,
};

export default TrustPilotWidget;
